(function () {
  var root = document.getElementById('rn-events-root');
  if (!root) {
    root = document.querySelector('section.rn-events');
  }
  if (!root) return;

  var labels = {
    back: root.getAttribute('data-label-back') || '',
    emptyTitle: root.getAttribute('data-label-empty-title') || '',
    emptyBody: root.getAttribute('data-label-empty-body') || '',
    about: root.getAttribute('data-label-about') || '',
    agenda: root.getAttribute('data-label-agenda') || '',
    notes: root.getAttribute('data-label-notes') || ''
  };

  var events = [];
  var dataEl = document.getElementById('rn-events-data');
  if (dataEl) {
    try {
      events = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      events = [];
    }
  }

  var store = {
    filter: 'all',
    events: events
  };
  window.__rnEventsStore = store;

  function classify(event) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var date = new Date(event.dateISO + 'T00:00:00');
    if (store.filter === 'all') return true;
    if (store.filter === 'upcoming') return date >= today;
    if (store.filter === 'past') return date < today;
    return event.dateISO.slice(0, 4) === store.filter;
  }

  function escapeHtml(s) {
    if (s == null || s === '') return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function coverBlock(ev, hero) {
    var url = ev.coverImage;
    if (url) {
      var alt = escapeHtml(ev.title || '');
      var cls = hero ? 'event-hero-img' : 'event-cover-img';
      return '<img class="' + cls + '" src="' + escapeHtml(url) + '" alt="' + alt + '" width="1600" height="1000" decoding="async" loading="lazy">';
    }
    var labelCls = hero ? 'event-hero-cover-label' : 'event-cover-label';
    return '<span class="' + labelCls + '">' + escapeHtml(ev.coverLabel || '') + '</span>';
  }

  function renderIndex() {
    var grid = root.querySelector('#events-grid');
    if (!grid) return;
    var filtered = store.events.filter(classify);
    grid.innerHTML = '';
    filtered.forEach(function (ev) {
      var card = document.createElement('article');
      card.className = 'event-card';
      card.setAttribute('onclick', "reNovaEventsShowEvent('" + ev.id + "')");
      card.innerHTML =
        '<div class="event-cover">' + coverBlock(ev, false) + '</div>' +
        '<div class="event-body">' +
          '<div class="event-title">' + escapeHtml(ev.title || '') + '</div>' +
          '<div class="event-meta">' + escapeHtml(ev.location || '') + ' • ' + escapeHtml(ev.dateLabel || '') + '</div>' +
          '<p class="event-summary">' + escapeHtml(ev.summary || '') + '</p>' +
        '</div>';
      grid.appendChild(card);
    });
    if (!filtered.length) {
      grid.innerHTML =
        '<div class="panel"><h3>' + escapeHtml(labels.emptyTitle) + '</h3><p>' + escapeHtml(labels.emptyBody) + '</p></div>';
    }
  }

  function renderDetails() {
    var wrap = root.querySelector('#event-pages');
    if (!wrap) return;
    wrap.innerHTML = '';
    store.events.forEach(function (ev) {
      var agenda = (ev.details.agenda || []).map(function (a) { return '<li>' + escapeHtml(a) + '</li>'; }).join('');
      var notes = (ev.details.notes || []).map(function (n) { return '<li>' + escapeHtml(n) + '</li>'; }).join('');
      wrap.innerHTML +=
        '<div id="page-' + ev.id + '" class="page">' +
          '<div class="events-shell">' +
            '<button class="back-btn" onclick="reNovaEventsShowPage(&quot;index&quot;)">' + escapeHtml(labels.back) + '</button>' +
            '<div class="event-hero">' +
              '<div class="event-hero-cover">' + coverBlock(ev, true) + '</div>' +
              '<div class="event-hero-body">' +
                '<h2 class="event-hero-title">' + escapeHtml(ev.title || '') + '</h2>' +
                '<div class="event-meta">' + escapeHtml(ev.location || '') + ' • ' + escapeHtml(ev.dateLabel || '') + '</div>' +
              '</div>' +
            '</div>' +
            '<div class="event-layout">' +
              '<div class="panel"><h3>' + escapeHtml(labels.about) + '</h3><p>' + escapeHtml(ev.details.intro || '') + '</p></div>' +
              '<div class="panel"><h3>' + escapeHtml(labels.agenda) + '</h3><ul>' + agenda + '</ul><h3 style="margin-top:0.9rem;">' + escapeHtml(labels.notes) + '</h3><ul>' + notes + '</ul></div>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
  }

  window.reNovaEventsSetFilter = function (filter, btn) {
    store.filter = filter;
    root.querySelectorAll('.events-tab').forEach(function (b) { b.classList.remove('active'); });
    if (btn) btn.classList.add('active');
    renderIndex();
  };

  window.reNovaEventsShowPage = function (name) {
    root.querySelectorAll('.page').forEach(function (p) { p.classList.remove('active'); });
    var page = root.querySelector('#page-' + name);
    if (page) page.classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  window.reNovaEventsShowEvent = function (id) {
    window.reNovaEventsShowPage(id);
  };

  window.reNovaEventsBoot = function () {
    renderDetails();
    renderIndex();
  };

  window.reNovaEventsBoot();
})();
